"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _functions = require("../../util/functions.js");

require("./StandardPerformanceRow.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StandardPerformanceRow =
/*#__PURE__*/
function (_Component) {
  _inherits(StandardPerformanceRow, _Component);

  function StandardPerformanceRow() {
    _classCallCheck(this, StandardPerformanceRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(StandardPerformanceRow).apply(this, arguments));
  }

  _createClass(StandardPerformanceRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fund = _this$props.fund,
          showCommonPeriod = _this$props.showCommonPeriod,
          showSinceInception = _this$props.showSinceInception,
          isPortfolio = _this$props.isPortfolio,
          hideCumulativeReturns = _this$props.hideCumulativeReturns,
          tickerToolip = _this$props.tickerToolip;

      if (fund.stdPerformance === null) {
        return null;
      } // Hide the Market Price (MP) row if the fund is a benchmark/index or non-WT Model Portfolio


      var hide = fund.type === 'BMK' || fund.type === 'WTIDX' || fund.type === 'MF' || isPortfolio && fund.type !== 'WTMOD';
      var yearStart = new Date(new Date().getFullYear(), 0, 1);
      var yearStartISO = yearStart.toISOString();
      var hideYTD = yearStartISO <= this.props.fund.inceptionDate ? true : false;
      var stdPerformance = Array.isArray(fund.stdPerformance) ? fund.stdPerformance[0] : fund.stdPerformance;
      return _react.default.createElement(_react.Fragment, null, tickerToolip && _react.default.createElement(_reactTooltip.default, {
        id: "".concat(fund.ticker, "-tooptip"),
        type: "light",
        className: "perf-ticker-tooltip",
        effect: "float"
      }, tickerToolip), _react.default.createElement("tr", {
        className: this.props.index === 0 ? 'whiteline' : 'greyline',
        key: Math.random()
      }, !isPortfolio ? fund.type === 'BMK' || fund.type === 'WTIDX' ? _react.default.createElement("td", {
        className: "textLeft row-name sticky ticker",
        style: {
          whiteSpace: 'nowrap'
        }
      }, fund.ticker, tickerToolip && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        style: {
          marginLeft: '4px',
          marginBottom: '8px',
          cursor: 'pointer'
        },
        "data-tip": true,
        "data-for": "".concat(fund.ticker, "-tooptip"),
        icon: "question-circle",
        size: "xs"
      }))) : _react.default.createElement("td", {
        className: "textLeft sticky ticker",
        style: {
          whiteSpace: 'nowrap'
        }
      }, _react.default.createElement("a", {
        className: "tickerLink",
        href: (0, _functions.getFundUrl)(fund),
        target: "_new"
      }, fund.ticker), tickerToolip && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        style: {
          marginLeft: '4px',
          marginBottom: '8px',
          cursor: 'pointer'
        },
        "data-tip": true,
        "data-for": "".concat(fund.ticker, "-tooptip"),
        icon: "question-circle",
        size: "xs"
      }))) : null, fund.type === 'BMK' || fund.type === 'WTIDX' || isPortfolio && fund.type !== 'WTMOD' ? _react.default.createElement("td", {
        className: (0, _classnames.default)('textLeft', 'name', isPortfolio ? 'sticky' : null, isPortfolio ? 'row-name' : null)
      }, fund.name.replace(/&amp;/g, '&').replace(/\(TR\)/g, '')) : _react.default.createElement("td", {
        className: (0, _classnames.default)('textLeft', 'name', isPortfolio ? 'sticky' : null, isPortfolio ? 'row-name' : null)
      }, fund.name.replace(/&amp;/g, '&') + ' (NAV)'), hideCumulativeReturns === false ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.mtdNAV)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.mos3NAV)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, hideYTD === true ? '-' : (0, _functions.formatPercent)(stdPerformance.ytdNAV))) : null, _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs1NAV)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs3NAV)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs5NAV)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs10NAV)), showSinceInception ? fund.type === 'BMK' ? _react.default.createElement("td", {
        className: "textCenter date"
      }, "-") : _react.default.createElement("td", {
        className: "textCenter date"
      }, (0, _functions.formatPercent)(stdPerformance.inceptionNAV)) : null, showCommonPeriod ? _react.default.createElement("td", {
        className: "textCenter date"
      }, (0, _functions.formatPercent)(stdPerformance.commonPeriodNAV)) : null), !hide && _react.default.createElement("tr", {
        className: "whiteline",
        key: Math.random()
      }, !isPortfolio ? _react.default.createElement("td", {
        className: "textLeft ticker sticky"
      }, "\xA0") : null, _react.default.createElement("td", {
        className: (0, _classnames.default)('textLeft', 'name', isPortfolio ? 'sticky' : null, isPortfolio ? 'row-name' : null)
      }, fund.name.replace(/&amp;/g, '&') + ' (MP)'), hideCumulativeReturns === false ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.mtdMP)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.mos3MP)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, hideYTD === true ? '-' : (0, _functions.formatPercent)(stdPerformance.ytdMP))) : null, _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs1MP)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs3MP)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs5MP)), _react.default.createElement("td", {
        className: "textCenter percentage"
      }, (0, _functions.formatPercent)(stdPerformance.yrs10MP)), showSinceInception ? _react.default.createElement("td", {
        className: "textCenter date"
      }, (0, _functions.formatPercent)(stdPerformance.inceptionMP)) : null, showCommonPeriod ? _react.default.createElement("td", {
        className: "textCenter date"
      }, (0, _functions.formatPercent)(stdPerformance.commonPeriodMP)) : null));
    }
  }]);

  return StandardPerformanceRow;
}(_react.Component);

_defineProperty(StandardPerformanceRow, "defaultProps", {
  showCommonPeriod: true,
  showSinceInception: true,
  isPortfolio: false,
  hideCumulativeReturns: false,
  tickerToolip: ''
});

StandardPerformanceRow.propTypes = {
  /**
   * Show the common period returns
   */
  showCommonPeriod: _propTypes.default.bool,

  /**
   * Show the since inception returns
   */
  showSinceInception: _propTypes.default.bool,

  /**
   * Indicate if the table is portfolio level
   */
  isPortfolio: _propTypes.default.bool,

  /**
   * Index of row
   */
  index: _propTypes.default.number,

  /**
  * Hide the Cumulative performance columns
  */
  hideCumulativeReturns: _propTypes.default.bool
};
var _default = StandardPerformanceRow;
exports.default = _default;